package com.anjuros.website.templates.template2.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.anjuros.website.components.shared.AnjurosLogo
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.templates.selection.util.Res
import com.anjuros.website.templates.template2.styles.CompanyColorVar
import com.anjuros.website.templates.template2.modules.Template2Section
import com.anjuros.website.templates.template2.modules.Template2Theme
import com.anjuros.website.templates.template2.modules.getColor
import com.anjuros.website.templates.template2.styles.Template2MenuWidthStyle
import com.anjuros.website.templates.template2.styles.Template2NavigationHeaderItemStyle
import com.anjuros.website.templates.template2.util.Template2Constants
import com.anjuros.website.templates.template2.util.Template2Res
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.ScrollBehavior
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color.Companion.argb
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.scrollBehavior
import com.varabyte.kobweb.compose.ui.modifiers.setVariable
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.translateY
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.navigation.OpenLinkStrategy
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun Template2OverflowMenu(onMenuClosed:()->Unit){

    val breakPoint = rememberBreakpoint()
    val scope = rememberCoroutineScope()
    var translateY by remember { mutableStateOf((-100).percent) }
    var opacity by remember { mutableStateOf(0.percent) }
    val color = Template2Theme.Primary.getColor()


    LaunchedEffect(breakPoint){
        translateY=0.percent
        opacity=100.percent
        if(breakPoint > Breakpoint.MD) {
            scope.launch {
                translateY=(-100).percent
                opacity=0.percent
                delay(500)
                onMenuClosed()
            }
        }
    }

    Column(modifier = Modifier
        .fillMaxWidth()
        .height(100.vh)
        .position(Position.Fixed)
        .zIndex(105)
        .opacity(opacity)
        .backgroundColor(argb(a=0.5f,r=0.0f,g=0.0f,b=0.0f))
        .transition(Transition.of(property = "opacity", duration = 500.ms))) {

        Column(modifier = Template2MenuWidthStyle.toModifier()
            .padding(25.px)
            .overflow(Overflow.Auto)
            .borderRadius(bottomRight = 20.px)
            .scrollBehavior(ScrollBehavior.Smooth)
            .backgroundColor(Template2Theme.Primary.getColor())
            .translateY(ty=translateY)
            .transition(Transition.of(property = "translate", duration = 500.ms))){

            Row(
                modifier = Modifier
                    .margin(bottom = 25.px),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.Start
            ){

                Image(
                    modifier =  Modifier
                        .cursor(Cursor.Pointer)
                        .color(Colors.White)
                        .margin(right = 10.px, bottom = 3.px)
                        .onClick {
                            scope.launch {
                                translateY=(-100).percent
                                opacity=0.percent
                                delay(500)
                                onMenuClosed()
                            }
                        },
                    src = Res.Icon.icon_x_white,
                    alt = "Close menu"
                )

                Box(
                    modifier = Modifier
                        .margin(left = 30.px)
                ) {
                    AnjurosLogo(
                        modifier = Modifier.size(45.px, 45.px),
                        src = Template2Res.Image.template2_logo2,
                        alt = "Affordable websites for UK sole traders"
                    )
                }

            }

            Template2Section.entries.toTypedArray().forEach { section->
                Link(
                    modifier = Modifier
                        .textDecorationLine(TextDecorationLine.None),
                    path = section.path,
                    openInternalLinksStrategy = OpenLinkStrategy.IN_PLACE
                ){
                    P(
                        attrs = Template2NavigationHeaderItemStyle.toModifier()
                            .setVariable(CompanyColorVar, color)
                            .margin(bottom = 10.px)
                            .fontFamily(Template2Constants.FONT_FAMILY)
                            .fontSize(16.px)
                            .color(Colors.White)
                            .fontWeight(FontWeight.Normal)
                            .onClick {
                                scope.launch {
                                    translateY=(-100).percent
                                    opacity=0.percent
                                    delay(500)
                                    onMenuClosed()
                                }
                            }
                            .toAttrs()
                    ) {
                        Text(LocalText(section.headerTitle))
                    }
                }

            }
        }

    }
}
